"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SlidingPanelSection = exports.SlidingPanelHeader = exports.ToggleIcon = exports.SlidingPanelDropdown = exports.slidingPanelDropdownStateToProps = exports.InternalSlidingPanelDropdown = exports.InternalToggleIcon = exports.SlidingPanel = exports.slidingPanelStateToProps = exports.InternalSlidingPanel = exports.slidingPanelActiveLens = exports.slidingPanelLens = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var R = _interopRequireWildcard(require("ramda"));

var _reactRedux = require("react-redux");

var _SlidingPanel = require("@cjdev-internal/visual-stack/lib/components/SlidingPanel");

var _actions = require("../actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var useFirstDefinedValue = function useFirstDefinedValue() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return R.reduce(function (acc, val) {
    return acc !== undefined ? acc : val;
  }, undefined, values);
};

var slidingPanelLens = R.lensPath(['visualStack', 'slidingPanel']);
exports.slidingPanelLens = slidingPanelLens;
var slidingPanelActiveLens = R.compose(slidingPanelLens, R.lensPath(['active']));
exports.slidingPanelActiveLens = slidingPanelActiveLens;

var InternalSlidingPanel =
/*#__PURE__*/
function (_Component) {
  _inherits(InternalSlidingPanel, _Component);

  function InternalSlidingPanel(props) {
    var _this;

    _classCallCheck(this, InternalSlidingPanel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InternalSlidingPanel).call(this, props));

    if (_this.props.syncStateToOpen) {
      _this.props.setSlidingPanelActiveState(true);
    }

    return _this;
  }

  _createClass(InternalSlidingPanel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$active = _this$props.active,
          active = _this$props$active === void 0 ? false : _this$props$active,
          children = _this$props.children,
          restProps = _objectWithoutProperties(_this$props, ["active", "children"]);

      return _react.default.createElement("div", {
        className: "vs-internal-sliding-panel"
      }, _react.default.createElement(_SlidingPanel.SlidingPanel, _extends({
        active: active
      }, restProps), children));
    }
  }]);

  return InternalSlidingPanel;
}(_react.Component);

exports.InternalSlidingPanel = InternalSlidingPanel;
InternalSlidingPanel.propTypes = {
  active: _propTypes.default.bool,
  initialActive: _propTypes.default.bool,
  children: _propTypes.default.any,
  toggleSlidingPanel: _propTypes.default.func,
  setSlidingPanelActiveState: _propTypes.default.func
};

var slidingPanelStateToProps = function slidingPanelStateToProps(state, ownProps) {
  var initialActive = ownProps.initialActive;
  var activeState = R.view(slidingPanelActiveLens, state);
  var active = useFirstDefinedValue(activeState, initialActive);
  var syncStateToOpen = !!(activeState === undefined && initialActive);
  return {
    active: active,
    syncStateToOpen: syncStateToOpen
  };
};

exports.slidingPanelStateToProps = slidingPanelStateToProps;
var SlidingPanel = (0, _reactRedux.connect)(slidingPanelStateToProps, {
  toggleSlidingPanel: _actions.toggleSlidingPanel,
  setSlidingPanelActiveState: _actions.setSlidingPanelActiveState
})(InternalSlidingPanel);
exports.SlidingPanel = SlidingPanel;

var InternalToggleIcon =
/*#__PURE__*/
function (_Component2) {
  _inherits(InternalToggleIcon, _Component2);

  function InternalToggleIcon(props) {
    var _this2;

    _classCallCheck(this, InternalToggleIcon);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(InternalToggleIcon).call(this, props));
    var eventSupportsPropagation = R.view(R.lensPath(['nativeEvent', 'stopImmediatePropagation']));

    _this2.handleClick = function (e) {
      if (eventSupportsPropagation(e)) e.nativeEvent.stopImmediatePropagation();

      _this2.props.toggleSlidingPanel();
    };

    return _this2;
  }

  _createClass(InternalToggleIcon, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      return _react.default.createElement(_SlidingPanel.ToggleIcon, _extends({}, R.dissoc('toggleSlidingPanel', this.props), {
        onClick: function onClick(e) {
          return _this3.handleClick(e);
        }
      }));
    }
  }]);

  return InternalToggleIcon;
}(_react.Component);

exports.InternalToggleIcon = InternalToggleIcon;
InternalToggleIcon.propTypes = {
  toggleSlidingPanel: _propTypes.default.func
};

var makeExpandedLens = function makeExpandedLens(_ref) {
  var id = _ref.id;
  return R.lensPath([id, 'expanded']);
};

var InternalSlidingPanelDropdown =
/*#__PURE__*/
function (_Component3) {
  _inherits(InternalSlidingPanelDropdown, _Component3);

  function InternalSlidingPanelDropdown(props) {
    var _this4;

    _classCallCheck(this, InternalSlidingPanelDropdown);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(InternalSlidingPanelDropdown).call(this, props));

    if (props.syncStateToOpen) {
      _this4.props.expandFilterDropdown();
    }

    return _this4;
  }

  _createClass(InternalSlidingPanelDropdown, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          restProps = _objectWithoutProperties(_this$props2, ["children"]);

      return _react.default.createElement(_SlidingPanel.SlidingPanelDropdown, restProps, children);
    }
  }]);

  return InternalSlidingPanelDropdown;
}(_react.Component);

exports.InternalSlidingPanelDropdown = InternalSlidingPanelDropdown;
InternalSlidingPanelDropdown.propTypes = {
  slidingPanel: _propTypes.default.object,
  id: _propTypes.default.string.isRequired,
  initialActive: _propTypes.default.bool,
  label: _propTypes.default.any,
  badge: _propTypes.default.any,
  children: _propTypes.default.any,
  toggleFilterDropdown: _propTypes.default.func,
  styles: _propTypes.default.object,
  expandFilterDropdown: _propTypes.default.func,
  hideFilterDropdown: _propTypes.default.func
};

var slidingPanelDropdownStateToProps = function slidingPanelDropdownStateToProps(state, ownProps) {
  var initialActive = ownProps.initialActive;
  var expandedState = R.view(R.compose(slidingPanelLens, makeExpandedLens(ownProps)), state);
  var expanded = useFirstDefinedValue(expandedState, initialActive);
  var syncStateToOpen = !!(expandedState === undefined && initialActive);
  return {
    expanded: expanded,
    syncStateToOpen: syncStateToOpen
  };
};

exports.slidingPanelDropdownStateToProps = slidingPanelDropdownStateToProps;
var SlidingPanelDropdown = (0, _reactRedux.connect)(slidingPanelDropdownStateToProps, function (dispatch, _ref2) {
  var id = _ref2.id;
  return {
    expandFilterDropdown: function expandFilterDropdown() {
      dispatch((0, _actions.expandFilterDropdown)(id));
    },
    hideFilterDropdown: function hideFilterDropdown() {
      dispatch((0, _actions.hideFilterDropdown)(id));
    },
    onClick: function onClick() {
      dispatch((0, _actions.toggleFilterDropdown)(id));
    }
  };
})(InternalSlidingPanelDropdown);
exports.SlidingPanelDropdown = SlidingPanelDropdown;
var ToggleIcon = (0, _reactRedux.connect)(function (state) {
  return {
    toggleIconState: R.view(slidingPanelActiveLens, state)
  };
}, {
  toggleSlidingPanel: _actions.toggleSlidingPanel
})(InternalToggleIcon);
exports.ToggleIcon = ToggleIcon;
var SlidingPanelHeader = _SlidingPanel.SlidingPanelHeader;
exports.SlidingPanelHeader = SlidingPanelHeader;
var SlidingPanelSection = _SlidingPanel.SlidingPanelSection;
exports.SlidingPanelSection = SlidingPanelSection;